"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Footer = void 0;
var _footer = _interopRequireDefault(require("./components/footer"));
exports.Footer = _footer["default"];